import api from "./interceptor";

export const subscribeUsersBatch = async (formData) => {
    try {
        const response = await api.post(`user/batch/subscribe-users`, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
        return response.data;
    } catch (e) {
        console.log(e.message);
    }
};

export const unsubscribeUsersBatch = async (file, mobileNumberArr) => {
    try {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("mobileNumberArr", mobileNumberArr);

        const response = await api.post(`user/batch/unsubscribe-users`, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
        return response.data;
    } catch (e) {
        console.log(e.message);
    }
};
